import { useState } from 'react';
import { supabase } from './supabase';

export default function Auth() {
  const [mode, setMode] = useState('login'); // 'login' | 'register' | 'forgot' | 'resend'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);

  const handle = async () => {
    setLoading(true);
    setMsg(null);
    try {
      if (mode === 'register') {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMsg({ type: 'ok', text: '¡Cuenta creada! Revisa tu email para confirmarla.' });
      } else if (mode === 'login') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else if (mode === 'forgot') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin });
        if (error) throw error;
        setMsg({ type: 'ok', text: 'Te hemos enviado un email para restablecer tu contraseña.' });
      } else if (mode === 'resend') {
        const { error } = await supabase.auth.resend({ type: 'signup', email });
        if (error) throw error;
        setMsg({ type: 'ok', text: '¡Email reenviado! Revisa tu bandeja de entrada (y el spam).' });
      }
    } catch (e) {
      const errMap = {
        'Invalid login credentials': 'Email o contraseña incorrectos.',
        'User already registered': 'Este email ya tiene una cuenta.',
        'Password should be at least 6 characters': 'La contraseña debe tener al menos 6 caracteres.',
        'Email not confirmed': 'Debes confirmar tu email antes de entrar.',
      };
      setMsg({ type: 'err', text: errMap[e.message] || e.message });
      if (e.message === 'Email not confirmed') setTimeout(() => setMode('resend'), 2000);
    }
    setLoading(false);
  };

  const titles = { login: '👋 Iniciar sesión', register: '🌱 Crear cuenta', forgot: '🔑 Recuperar contraseña', resend: '📧 Reenviar confirmación' };
  const btnLabels = { login: 'Entrar', register: 'Crear cuenta', forgot: 'Enviar email', resend: 'Reenviar email' };
  const showPassword = mode === 'login' || mode === 'register';

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg,#fdf0ff,#f0f4ff 50%,#fff0f8)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: 'Nunito, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 44, marginBottom: 8 }}>🌸</div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 900, color: '#5a3870' }}>HKIA Flores</h1>
          <p style={{ margin: '6px 0 0', fontSize: 13, color: '#c0a0c8', fontWeight: 600 }}>Hello Kitty Island Adventure</p>
        </div>

        <div style={{ background: '#fff', borderRadius: 24, padding: '28px 24px', boxShadow: '0 4px 30px rgba(180,130,220,0.15)', border: '1.5px solid #f0d8f8' }}>
          <h2 style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 900, color: '#5a3870', textAlign: 'center' }}>{titles[mode]}</h2>

          {mode === 'resend' && (
            <p style={{ fontSize: 12, color: '#a080c0', textAlign: 'center', margin: '0 0 14px', lineHeight: 1.5 }}>
              Introduce tu email y te reenviaremos el enlace de confirmación.
            </p>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={lbl}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" style={inp} onKeyDown={e => e.key === 'Enter' && handle()} />
            </div>
            {showPassword && (
              <div>
                <label style={lbl}>Contraseña</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={mode === 'register' ? 'Mínimo 6 caracteres' : '••••••••'} style={inp} onKeyDown={e => e.key === 'Enter' && handle()} />
              </div>
            )}
            {msg && (
              <div style={{ background: msg.type === 'ok' ? '#e8f8e8' : '#fce8e8', border: `1.5px solid ${msg.type === 'ok' ? '#b0e0b0' : '#f0b0b0'}`, borderRadius: 10, padding: '8px 12px', fontSize: 12, color: msg.type === 'ok' ? '#408040' : '#c04040', fontWeight: 600 }}>
                {msg.type === 'ok' ? '✓ ' : '⚠ '}{msg.text}
              </div>
            )}
            <button onClick={handle} disabled={loading}
              style={{ padding: '12px', borderRadius: 12, border: 'none', background: loading ? '#e8d8f0' : 'linear-gradient(135deg,#e070c8,#8858d0)', color: loading ? '#c0a0d0' : '#fff', fontWeight: 800, fontSize: 14, cursor: loading ? 'default' : 'pointer', fontFamily: 'Nunito, sans-serif', boxShadow: loading ? 'none' : '0 2px 10px #d090d055', transition: 'all 0.2s', marginTop: 4 }}>
              {loading ? '⏳ Un momento...' : btnLabels[mode]}
            </button>
          </div>

          <div style={{ marginTop: 18, display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
            {mode === 'login' && <>
              <button onClick={() => { setMode('register'); setMsg(null); }} style={link}>¿No tienes cuenta? Regístrate</button>
              <button onClick={() => { setMode('forgot'); setMsg(null); }} style={{ ...link, fontSize: 11, color: '#c0a0c8' }}>¿Olvidaste tu contraseña?</button>
              <button onClick={() => { setMode('resend'); setMsg(null); }} style={{ ...link, fontSize: 11, color: '#c0a0c8' }}>¿No te llegó el email de confirmación?</button>
            </>}
            {mode === 'register' && <button onClick={() => { setMode('login'); setMsg(null); }} style={link}>¿Ya tienes cuenta? Inicia sesión</button>}
            {(mode === 'forgot' || mode === 'resend') && <button onClick={() => { setMode('login'); setMsg(null); }} style={link}>Volver al inicio de sesión</button>}
          </div>
        </div>

        <p style={{ textAlign: 'center', fontSize: 10, color: '#d0b8e0', marginTop: 16, fontWeight: 600 }}>
          Guías por <a href="https://www.instagram.com/microjessii" target="_blank" rel="noopener noreferrer" style={{ color: '#d0b8e0', textDecoration: 'none', fontWeight: 800 }}>@microjessii</a> · Tracker con ayuda de Claude ✨
        </p>
      </div>
    </div>
  );
}

const lbl = { display: 'block', fontSize: 10, fontWeight: 700, color: '#c0a0d0', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.4, fontFamily: 'Nunito, sans-serif' };
const inp = { width: '100%', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #e8d0f0', fontSize: 13, fontFamily: 'Nunito, sans-serif', color: '#7a5090', outline: 'none', boxSizing: 'border-box', background: '#faf5ff' };
const link = { background: 'none', border: 'none', color: '#b080d0', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Nunito, sans-serif', textDecoration: 'underline' };
